module.exports = __webpack_public_path__ + "static/media/help-circle-blue.556bf7fe.svg";